module.exports = __webpack_public_path__ + "img/hygiene-case1.8d6f0ee3.jpg";